<template>
  <div class="list-img">
    <div v-for="item in deviceInfo" :key="item.deviceId" class="list-item">
      <img
        src="@src/common/assets/images/device.png"
        alt=""
        @click="handleView"
        class="list-item-img"
      />
      <!-- :style="{
          height: getHeight(item),
        }" -->
      <div style="flex: 1">
        <span class="list-item-label">
          {{ item.deviceName }}
        </span>
        <div class="list-item-wrap">
          <div
            v-for="(items, key, index) in item.deviceStatusMap"
            :key="index"
            :class="
              key == 0 && !item.deviceStatusMap[Number(key) + 1]
                ? 'single list-item-content'
                : 'list-item-content'
            "
          >
            <div class="list-item-title" v-if="key != 0">
              <img
                src="@src/common/assets/images/deviceIcon.png"
                style="margin-right: 4px"
              />
              {{ key + "#" }}
            </div>
            <div style="width: 100%; display: flex; flex-wrap: wrap">
              <div v-for="(itemT, indexT) in items" :key="indexT" class="item">
                <!-- padding-left: 22% -->
                <div
                  :class="[
                    'list-item-icon',
                    itemT.currentStatus == 1 ? 'list-item-green' : '',
                  ]"
                >
                  <div v-if="itemT.currentStatus == 1"></div>
                </div>
                <span>
                  {{
                    itemT.currentStatusName.split("#")[
                      itemT.currentStatusName.split("#").length - 1
                    ]
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    deviceInfo: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      chart: {},
    };
  },
  mounted() {},
  methods: {
    handleView(e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    getHeight(item) {
      if (item.deviceStatusMap) {
        let height = Math.ceil(Object.keys(item.deviceStatusMap).length / 5) * 110;
        return height < 160 ? "160px" : height + "px";
      } else {
        return "160px";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.list {
  &-img {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    // border: 1px solid red;
    // padding: 24px 12px 0;
  }
  &-item {
    display: flex;
    width: calc(100%);
    margin-bottom: 12px;
    @include set_theme_color(background-color, page-default-bg);
    padding: 16px;
  }
  &-item-img {
    width: 10%;
    max-width: 170px;
    margin-right: 16px;
    cursor: pointer;
    // min-height: 160px;
  }
  &-item-wrap {
    display: flex;
    flex-wrap: wrap;
    // height: calc(100% - 16px);
    // justify-content: space-between;
    // align-items: flex-end;
  }
  &-item-content {
    position: relative;
    display: flex;
    align-items: center;
    @include set_theme_color(background-color, page-bg-color);
    // width: 32%;
    width: calc((100% - 64px) / 9);
    // height: 40%;
    // border: 1px solid red;
    flex-direction: column;
    padding: 6px 0;
    margin-top: 10px;
    // margin-right: calc(10% / 8);
    margin-right: 8px;
    &:nth-child(9n + 0) {
      margin-right: 0;
    }
    &.single {
      width: 40%;
      .item {
        display: flex;
        align-items: center;
        width: auto !important;
      }
    }
    .item {
      display: flex;
      align-items: center;
      width: 100%;
    }
  }
  &-item-title {
    display: flex;
    width: 100%;
    padding-left: 12px;
    height: 17px;
    color: #ffffff;
    line-height: 17px;
  }
  &-item-icon {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    margin: 5px 10px 5px 16px;
    border: 1px solid #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }
  }
  &-item-gray {
    background: #4b5566;
  }
  &-item-red {
    background: rgba(217, 0, 27, 1);
  }
  &-item-green {
    background: rgba(149, 242, 4, 1);
    // border: 1px solid #3f97e7;
    div {
      // background: #3f97e7;
      background: rgba(149, 242, 4, 1);
    }
  }
  &-item-label {
    font-size: 16px;
  }
}
</style>
